export default function GoogleIcon({
  name,
  size = 18,
  color = 'inherit',
  filled = false,
  weight = 400,
  grade = 0,
  opticalSize = 24,
  className = '',
  style = {},
  ariaHidden = true
}) {
  if (!name) return null

  return (
    <span
      className={`material-symbols-outlined ${className}`}
      aria-hidden={ariaHidden}
      translate="no"
      style={{
        fontSize: size,
        color,
        fontVariationSettings: `
          'FILL' ${filled ? 1 : 0},
          'wght' ${weight},
          'GRAD' ${grade},
          'opsz' ${opticalSize}
        `,
        ...style
      }}
    >
      {name}
    </span>
  )
}
